import type {Thread} from '@github-ui/diff-lines/conversation-types'

import {ChevronRightIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {PreviewAuthors} from './PreviewAuthors'
import {useCommentReplyActions} from '../../stores/layout-selectors'
import {getFirstComment} from '../../page-data/payloads/thread-previews'

type Props = {
  thread: Thread
  displayedCommentId?: number | null
  replyCount: number
  onBeforeOpenReplyDetail?: (triggerElement: HTMLElement | null) => void
}

export const OpenThreadRepliesButton = ({thread, displayedCommentId, replyCount, onBeforeOpenReplyDetail}: Props) => {
  const {openReplyDetail} = useCommentReplyActions()
  const firstComment = getFirstComment(thread)
  const commentId = displayedCommentId ?? firstComment?.databaseId
  const repliesText =
    replyCount === 0 ? 'No replies. Add a reply' : `${replyCount} ${replyCount === 1 ? 'reply' : 'replies'}`

  return (
    <Button
      size="small"
      trailingVisual={ChevronRightIcon}
      variant="invisible"
      onClick={event => {
        onBeforeOpenReplyDetail?.(event.currentTarget)
        openReplyDetail(thread.id)
      }}
    >
      <div className="d-flex flex-row flex-justify-start flex-items-center gap-2">
        <span>{repliesText}</span>
        <PreviewAuthors thread={thread} skipBeforeCommentId={commentId} />
      </div>
    </Button>
  )
}
